import { render, staticRenderFns } from "./Xinbox.vue?vue&type=template&id=3dd6de30&"
import script from "./Xinbox.vue?vue&type=script&lang=js&"
export * from "./Xinbox.vue?vue&type=script&lang=js&"
import style0 from "./Xinbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports